// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppBanner_wrapper__c_iLK","text-section":"AppBanner_text-section__myHO8","banner-section":"AppBanner_banner-section___wrxG","badge-link":"AppBanner_badge-link__y8CLg"};